// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6755a0db","732":"a0eaceef","977":"7f81b5c6"}[chunkId] + ".chunk.js";
};